import { useLanguage } from "@/context/LanguageContext";

export default function AnnouncementBar() {
  const { t } = useLanguage();
  return (
    <div
      data-testid="announcement-bar"
      className="w-full bg-[#111111] px-4 py-2.5 text-center"
    >
      <p className="font-body text-[11px] tracking-[0.14em] text-white/85 sm:text-xs">
        {t.announcement}
      </p>
    </div>
  );
}
